import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import ReactPlayer from "react-player";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import bannerImage from "../assets/fondos/3.jpg";
import WhatsAppButton from "../components/WhatsAppButton";
import LandingChatbot from "../components/LandingChatbot";
import { Helmet } from "react-helmet";
import cirpImage from "../assets/logok.png";
import useFacebookPixel from "../hooks/useFacebookPixel";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import "./usuario.css";
import "./recuadro.css";
import "./AudienciaLanding.css";
import SocialButtons from "../components/SocialButton";
import MicrosoftClarity from '../components/MicrosoftClarity';


const Usuario = () => {
  const { usuario } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [userdata, setUserdata] = useState({});
  const [Pixels, setPixels] = useState("");
  const [Clarity, setClarity] = useState("");
  const [encuesta, setencuesta] = useState("");
  const [played, setPlayed] = useState(0);
  const [showQuestion, setShowQuestion] = useState(false);
  const [showReplayButton, setShowReplayButton] = useState(false);
  const [modal, setModal] = useState(true);
  const [surveyCompleted, setSurveyCompleted] = useState(false);
  const [formData, setFormData] = useState({
    nombre: "",
    correo: "",
    telefono: "",
  });
  const [error, setError] = useState(false);
  const playerRef = useRef(null);

  const { trackContact, trackViewContent, CompleteRegistration, trackLead } =
    useFacebookPixel(usuario, {
      creadorId: userdata?.creador,
      campana: data?.nombrecampana,
      red: "facebook",
    });

  // Obtener el ID del usuario logueado desde el almacenamiento local
  const loginUserJSON = window.localStorage.getItem("loginUser");
  const loggedInUser = loginUserJSON ? JSON.parse(loginUserJSON) : null;
  const userId = loggedInUser ? loggedInUser.id : null;
  const userRole = loggedInUser ? loggedInUser.rol : null;
  const userWS = loggedInUser ? loggedInUser.tlfwhatsapp : null;
  
const hasAnySocialLink = 
  (userdata && userdata.pdf) || 
  (userdata && userdata.facebook) || 
  (userdata && userdata.instagram) || 
  (userdata && userdata.linkedin) || 
  (userdata && userdata.tiktok) || 
  (userdata && userdata.calendly);

  useEffect(() => {
    const fetchData = async () => {
      try {
        console.log('=== CARGANDO CAMPAÑA DE VIDEO ===');
        console.log('Usuario/Enlace:', usuario);
        console.log('URL:', `https://api.mrcirp.com/public/usuariolanding/${usuario}`);
        
        const response = await axios.get(
          `https://api.mrcirp.com/public/usuariolanding/${usuario}`
        );
        
        console.log('=== RESPUESTA DEL SERVIDOR ===');
        console.log('Status:', response.status);
        console.log('Response data completo:', response.data);
        console.log('Response data[0]:', response.data[0]);
        
        if (response.data && response.data.length > 0) {
          console.log('✅ Campaña encontrada');
          console.log('Datos de la campaña:', JSON.stringify(response.data[0], null, 2));
          setData(response.data[0]);
        } else {
          console.error('❌ No se encontró la campaña - response.data está vacío');
          console.error('Response.data:', response.data);
        }
      } catch (error) {
        console.error("=== ERROR AL CARGAR CAMPAÑA ===");
        console.error("Error completo:", error);
        console.error("Error message:", error.message);
        console.error("Error response:", error.response);
        console.error("Error response data:", error.response?.data);
        console.error("Error response status:", error.response?.status);
      }
    };

    const fetchUserInfo = async () => {
      try {
        const response = await axios.get(
          `https://api.mrcirp.com/public/infocampanas/${usuario}`
        );
        setUserdata(response.data[0]);
      } catch (error) {
        console.error("Error fetching user info:", error);
      }
    };

    const pixelsuser = async () => {
      try {
        const response = await axios.get(
          `https://api.mrcirp.com/public/userpixels/${usuario}`
        );
        setPixels(response.data[0]);
      } catch (error) {
        console.error("Error fetching user info:", error);
      }
    };

    const clarityuser = async () => {
      try {
        const response = await axios.get(
          `https://api.mrcirp.com/public/userclarity/${usuario}`
        );
        setClarity(response.data[0]);
      } catch (error) {
        console.error("Error fetching user info:", error);
      }
    };

    const encuestauser = async () => {
      try {
        const response = await axios.get(
          `https://api.mrcirp.com/public/encuestacampana/${usuario}`
        );
        setencuesta(response.data[0]);
       
      } catch (error) {
        console.error("Error fetching user info:", error);
      }
    };

    fetchData();
    fetchUserInfo();
    pixelsuser();
    encuestauser();
    clarityuser();
  }, [usuario]);

  const handleProgress = (state) => {
    if (!playerRef.current.seeking) {
      setPlayed(state.played);
    } else {
      playerRef.current.seekTo(played);
    }
  };

  const handleEnded = () => {
    setShowQuestion(true);
    setShowReplayButton(true);
  };

  const handleReplay = () => {
    setShowQuestion(false);
    setShowReplayButton(false);
    playerRef.current.seekTo(0);
  };

  const handleOptionA = () => {
    trackViewContent();
    navigate(`/producto1/${usuario}`);
  };

  const handleOptionB = () => {
    trackViewContent();
    navigate(`/negocio1/${usuario}`);
  };

  const handleOptionC = () => {
    navigate("/salir");
  };

  const handleBack = () => {
    if (userRole === "admin") {
      navigate("/inicio");
    } else if (userRole === "cliente") {
      navigate("/iniciouser");
    } else {
      navigate(-1);
    }
  };

  const handleSurveyResponse = (response) => {
    setSurveyCompleted(true);

    switch (response) {
      case "interested":
        trackViewContent();
        break;
      case "more_info":
        trackViewContent();
        break;
      default:
        break;
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handlePhoneChange = (value) => {
    setFormData({ ...formData, telefono: value });
  };

  // Función para insertar contacto en Brevo (por campaña)
  const insertContactToBrevo = async (creadorId, nombreCampana) => {
    try {
      console.log("Intentando insertar contacto en Brevo para creador:", creadorId);
      console.log("Campaña:", nombreCampana);

      // 1) Intentar obtener Brevo relacionado a la campaña
      let cred = null;
      try {
        if (nombreCampana && String(nombreCampana).trim()) {
          const lista = await axios.get(`https://api.mrcirp.com/public/brevocampanas/${creadorId}`);
          const match = (lista.data || []).find(
            (r) =>
              String(r?.campana || "").trim().toLowerCase() ===
              String(nombreCampana).trim().toLowerCase()
          );
          if (match?.api_key) cred = match;
        }
      } catch (e) {
        // Si falla, usamos fallback GLOBAL
      }

      // 2) Fallback a Brevo GLOBAL del creador
      if (!cred) {
        const brevoResponse = await axios.get(`https://api.mrcirp.com/public/brevo/${creadorId}`);
        if (brevoResponse.data && brevoResponse.data[0] && brevoResponse.data[0].api_key) {
          cred = brevoResponse.data[0];
        }
      }

      if (cred && cred.api_key) {
        const { user_id, api_key } = cred;

        // Preparar datos del contacto (igual que en el formulario de prueba)
        const contactData = {
          email: formData.correo.trim(),
          updateEnabled: false
        };

        // Agregar nombre y apellido si está presente (dividir el nombre completo)
        if (formData.nombre && formData.nombre.trim()) {
          const nombreParts = formData.nombre.trim().split(' ');
          contactData.attributes = {};
          if (nombreParts.length > 0) {
            contactData.attributes.NOMBRE = nombreParts[0];
          }
          if (nombreParts.length > 1) {
            contactData.attributes.APELLIDO = nombreParts.slice(1).join(' ');
          }
        }

        // Agregar teléfono si está presente
        if (formData.telefono) {
          if (!contactData.attributes) {
            contactData.attributes = {};
          }
          // PhoneInput con international devuelve formato E.164 (ej: +51987654321)
          // Brevo acepta formato con código de país: +91xxxxxxxxxx o 0091xxxxxxxxxx
          // Usar el valor tal cual viene de PhoneInput (ya tiene el formato correcto)
          contactData.attributes.SMS = formData.telefono.trim();
        }

        // Agregar ID de lista si está configurado
        if (user_id && user_id.trim()) {
          const listId = parseInt(user_id.trim());
          if (!isNaN(listId)) {
            contactData.listIds = [listId];
          }
        }

        console.log('=== DATOS A ENVIAR A BREVO ===');
        console.log('URL:', 'https://api.brevo.com/v3/contacts');
        console.log('Headers:', {
          'accept': 'application/json',
          'content-type': 'application/json',
          'api-key': api_key.trim().substring(0, 20) + '...' // Solo mostrar primeros caracteres por seguridad
        });
        console.log('Body completo:', JSON.stringify(contactData, null, 2));

        // Insertar contacto en Brevo
        const response = await axios({
          method: 'POST',
          url: 'https://api.brevo.com/v3/contacts',
          headers: {
            'accept': 'application/json',
            'content-type': 'application/json',
            'api-key': api_key.trim()
          },
          data: contactData
        });

        console.log('=== RESPUESTA EXITOSA DE BREVO ===');
        console.log('Status:', response.status);
        console.log('Status Text:', response.statusText);
        console.log('Headers:', response.headers);
        console.log('Data:', JSON.stringify(response.data, null, 2));
      } else {
        console.log('No se encontraron credenciales de Brevo para el usuario');
      }
    } catch (err) {
      // No mostrar error al usuario si falla Brevo, solo loguear
      console.error('=== ERROR AL INSERTAR CONTACTO EN BREVO ===');
      console.error('Error completo:', err);
      console.error('Error message:', err.message);
      console.error('Error code:', err.code);
      
      if (err.response) {
        console.error('Status:', err.response.status);
        console.error('Status Text:', err.response.statusText);
        console.error('Headers:', err.response.headers);
        console.error('Data (error completo):', JSON.stringify(err.response.data, null, 2));
        console.error('Request URL:', err.config?.url);
        console.error('Request method:', err.config?.method);
        console.error('Request data:', JSON.stringify(err.config?.data, null, 2));
      } else if (err.request) {
        console.error('Request enviado pero sin respuesta:', err.request);
      } else {
        console.error('Error al configurar la petición:', err.message);
      }
    }
  };

const peticionPost = async () => {
    const nuevoLeadConUsuario = {
        ...formData,
        iduser: userdata?.creador,
        usuario: usuario,
        correodestinario: userdata?.correo,
    };

    // Mostrar los datos que se van a enviar
    console.log("Datos a enviar:", nuevoLeadConUsuario);

    try {
        // Primera petición
        console.log("Enviando datos a leadsnuevos...");
        const res1 = await axios.post(
            "https://api.mrcirp.com/public/leadsnuevos",
            nuevoLeadConUsuario,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        console.log("Respuesta de leadsnuevos:", res1.data);

        // Segunda petición
        console.log("Enviando datos a enviarcorreoleads...");
        const res2 = await axios.post(
            "https://api.mrcirp.com/enviarcorreoleads.php",
            nuevoLeadConUsuario,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        console.log("Respuesta de enviarcorreoleads:", res2.data);

        // Insertar contacto en Brevo si el creador tiene Brevo configurado (por campaña)
        if (userdata?.creador) {
          await insertContactToBrevo(userdata.creador, data?.nombrecampana);
        }

        CompleteRegistration();
        setError(false);
        setModal(false);
    } catch (err) {
        console.error("Error submitting form:", err);
        setError(true);
    }
};

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.nombre || !formData.correo || !formData.telefono) {
      alert("Por favor, completa todos los campos.");
      return;
    }
    peticionPost();
  };

  if (!data) {
    console.log('⏳ Esperando datos... data es:', data);
    return <div>Loading...</div>;
  }

  console.log('=== RENDERIZANDO COMPONENTE ===');
  console.log('Data disponible:', data);
  console.log('nombrecampana:', data.nombrecampana);
  console.log('urlvideo:', data.urlvideo);
  console.log('descripcion:', data.descripcion);
  console.log('=== CAMPOS NUEVOS ===');
  console.log('servicios_titulo:', data.servicios_titulo);
  console.log('servicios_descripcion:', data.servicios_descripcion);
  console.log('servicios_items:', data.servicios_items);
  console.log('dos_columnas_titulo:', data.dos_columnas_titulo);
  console.log('dos_columnas_descripcion:', data.dos_columnas_descripcion);
  console.log('dos_columnas_imagen:', data.dos_columnas_imagen);
  console.log('dos_columnas_derecha_titulo:', data.dos_columnas_derecha_titulo);
  console.log('dos_columnas_derecha_descripcion:', data.dos_columnas_derecha_descripcion);
  console.log('dos_columnas_derecha_imagen:', data.dos_columnas_derecha_imagen);
  console.log('banner_titulo:', data.banner_titulo);
  console.log('banner_subtitulo:', data.banner_subtitulo);
  console.log('banner_video_url:', data.banner_video_url);
  console.log('banner_imagen_url:', data.banner_imagen_url);

  return (
    <div style={styles.container}>
      <Helmet>
        <title>{usuario}</title>
        <meta name="description" content={`Pixels: ${Pixels}`} />
      </Helmet>
   {Clarity?.clarity && <MicrosoftClarity trackingId={Clarity.clarity} />}
      
      {/* Banner Section - Ahora abarca también el área del video */}
      <div 
        style={{
          ...styles.bannerSection,
          backgroundImage: data.banner_imagen_url ? `url(${data.banner_imagen_url})` : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          minHeight: 'auto',
          paddingBottom: '60px'
        }}
      >
        <div style={styles.content}>
          {/* Título y subtítulo del banner encima del video */}
          {(data.banner_titulo || data.banner_subtitulo) && (
            <div style={styles.bannerContent}>
              {data.banner_titulo && (
                <h1 
                  style={styles.bannerTitle}
                  dangerouslySetInnerHTML={{ __html: data.banner_titulo }}
                />
              )}
              {data.banner_subtitulo && (
                <p 
                  style={styles.bannerSubtitle}
                  dangerouslySetInnerHTML={{ __html: data.banner_subtitulo }}
                />
              )}
            </div>
          )}

        <div className="row">
          <div
            className={
              showQuestion ? "col-md-6 col-sm-12" : "col-md-12 col-sm-12"
            }
          >
            <div style={styles.videoWrapperFull}>
              <div style={styles.videoWrapper}>
                {!showReplayButton && data.urlvideo ? (
                  <ReactPlayer
                    ref={playerRef}
                    url={data.urlvideo}
                    width="100%"
                    height="100%"
                    controls={false}
                    onProgress={handleProgress}
                    onEnded={handleEnded}
                    style={styles.video}
                  />
                ) : (
                  <div className="recuadro" style={styles.replayContainer}>
                    <img
                      src={cirpImage}
                      alt="KATANA"
                      style={styles.replayImage}
                    />
                    <button style={styles.button} onClick={handleReplay}>
                      Reproducir nuevamente
                    </button>
                  </div>
                )}
              </div>

              {encuesta && (
  <div className="recuadro" style={styles.surveyContainer}>
    {surveyCompleted ? (
      <div style={styles.thankYouMessage}>
        <h4>¡Gracias por tu respuesta!</h4>
        <p>Valoramos mucho tu opinión.</p>
      </div>
    ) : (
      
      <>
        <h4 style={{ color: '#333', marginBottom: '20px', fontSize: '18px', fontWeight: '600' }}>{encuesta.pregunta}</h4>
        <div style={styles.surveyButtons}>
          <button
            style={styles.surveyButton}
            onClick={() => {
              if (encuesta.evento_1 === "cliente potencial") {
                trackLead();
              }
              setSurveyCompleted(true);
            }}
          >
            {encuesta.respuesta_1}
          </button>
          <button
            style={styles.surveyButton}
            onClick={() => {
              if (encuesta.evento_2 === "cliente potencial") {
                trackLead();
              }
              setSurveyCompleted(true);
            }}
          >
            {encuesta.respuesta_2}
          </button>
          <button
            style={styles.surveyButton}
            onClick={() => {
              if (encuesta.evento_3 === "cliente potencial") {
                trackLead();
              }
              setSurveyCompleted(true);
            }}
          >
            {encuesta.respuesta_3}
          </button>
        </div>
      </>
    )}
  </div>
)}
            </div>
          </div>

            {showQuestion && (
              <div className="col-md-6 col-sm-12">
                <div className="recuadro" style={styles.question}>
                  <h4 style={{ color: '#333', marginBottom: '24px', fontSize: '20px', fontWeight: '600' }}>
                    {data?.banner_pregunta_texto || '¿Qué le pareció el video? … ¿Sorprendente cierto? ¿Como deseas continuar?'}
                  </h4>
                  <button style={styles.button} onClick={handleOptionA}>
                    {data?.banner_boton_a ? `A) ${data.banner_boton_a}` : 'A) SÍ QUIERO MÁS INFORMACIÓN DEL PRODUCTO'}
                  </button>
                  <button style={styles.button} onClick={handleOptionB}>
                    {data?.banner_boton_b ? `B) ${data.banner_boton_b}` : 'B) QUIERO CONOCER MÁS DEL NEGOCIO'}
                  </button>
                  <button style={styles.button} onClick={handleOptionC}>
                    {data?.banner_boton_c ? `C) ${data.banner_boton_c}` : 'C) NO GRACIAS, DESEO SALIR'}
                  </button>
                  <button style={styles.button} onClick={handleBack}>
                    {data?.banner_boton_volver || 'VOLVER'}
                  </button>
                </div>
              </div>
            )}
        </div>
        </div>
      </div>

      {/* Sección de Servicios */}
      {data.servicios_titulo && (
        <section 
          className="servicios-section"
          style={{
            backgroundImage: data.servicios_fondo_imagen ? `url(${data.servicios_fondo_imagen})` : 'none',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'fixed'
          }}
        >
          <div className="container">
            <div className="section-header">
              <h2 
                className="section-title"
                dangerouslySetInnerHTML={{ __html: data.servicios_titulo || '' }}
              />
              {data.servicios_descripcion && (
                <p 
                  className="section-description"
                  dangerouslySetInnerHTML={{ __html: data.servicios_descripcion }}
                />
              )}
            </div>
            
            {data.servicios_items && (() => {
              let serviciosItems = [];
              try {
                serviciosItems = typeof data.servicios_items === 'string' 
                  ? JSON.parse(data.servicios_items) 
                  : data.servicios_items;
                if (!Array.isArray(serviciosItems)) serviciosItems = [];
              } catch (e) {
                console.error('Error parsing servicios_items:', e);
              }
              
              return serviciosItems.length > 0 ? (
                <div className="servicios-grid">
                  {serviciosItems.map((item, index) => (
                    <div key={index} className="servicio-card">
                      <h3 
                        className="servicio-title"
                        dangerouslySetInnerHTML={{ __html: item.titulo || '' }}
                      />
                      <p 
                        className="servicio-description"
                        dangerouslySetInnerHTML={{ __html: item.descripcion || '' }}
                      />
                    </div>
                  ))}
                </div>
              ) : null;
            })()}
          </div>
        </section>
      )}

      {/* Sección de Dos Columnas (Imagen Izquierda) */}
      {data.dos_columnas_titulo && (
        <section 
          className="dos-columnas-section"
          style={{
            backgroundImage: data.dos_columnas_fondo_imagen ? `url(${data.dos_columnas_fondo_imagen})` : 'none',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'fixed'
          }}
        >
          <div className="container">
            <div className="dos-columnas-content">
              <div className="column-left">
                {data.dos_columnas_imagen && (
                  <div className="image-container">
                    <img 
                      src={data.dos_columnas_imagen} 
                      alt={data.dos_columnas_titulo}
                      className="section-image"
                    />
                  </div>
                )}
              </div>
              <div className="column-right">
                <h2 
                  className="section-title"
                  dangerouslySetInnerHTML={{ __html: data.dos_columnas_titulo || '' }}
                />
                {data.dos_columnas_descripcion && (
                  <p 
                    className="section-description"
                    dangerouslySetInnerHTML={{ __html: data.dos_columnas_descripcion }}
                  />
                )}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Sección de Dos Columnas (Imagen Derecha) */}
      {data.dos_columnas_derecha_titulo && (
        <section 
          className="dos-columnas-section reverse"
          style={{
            backgroundImage: data.dos_columnas_derecha_fondo_imagen ? `url(${data.dos_columnas_derecha_fondo_imagen})` : 'none',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'fixed'
          }}
        >
          <div className="container">
            <div className="dos-columnas-content">
              <div className="column-right">
                <h2 
                  className="section-title"
                  dangerouslySetInnerHTML={{ __html: data.dos_columnas_derecha_titulo || '' }}
                />
                {data.dos_columnas_derecha_descripcion && (
                  <p 
                    className="section-description"
                    dangerouslySetInnerHTML={{ __html: data.dos_columnas_derecha_descripcion }}
                  />
                )}
              </div>
              <div className="column-left">
                {data.dos_columnas_derecha_imagen && (
                  <div className="image-container">
                    <img 
                      src={data.dos_columnas_derecha_imagen} 
                      alt={data.dos_columnas_derecha_titulo}
                      className="section-image"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Footer */}
      <footer className="landing-footer">
        <div className="container">
          <div className="footer-content">
            <p className="footer-text">
              © 2024 KATANA - Constructor de Ingresos Residuales Perpetuos
            </p>
          </div>
        </div>
      </footer>

      <WhatsAppButton
        phoneNumber={userdata?.whatsapp}
        message="Hola, me gustaría obtener más información."
        onContactClick={trackContact}
      />
      
      <LandingChatbot />
      
      {/* Botones Sociales - Ocultos en la landing de bienvenida de campañas de video */}

      <Modal isOpen={modal} centered>
        <ModalHeader style={{ position: "relative" }}>
          <div
            style={{
              position: "absolute",
              right: "20px",
              top: "15px",
              cursor: "pointer",
              zIndex: 1,
            }}
            onClick={() => setModal(false)}
          >
            ×
          </div>
          <h6 style={{ textAlign: "center", paddingRight: "30px" }}>
            {userdata?.texto_modal}
          </h6>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={handleSubmit}>
            <FormGroup>
              <Label for="nombre">Nombre</Label>
              <Input
                type="text"
                name="nombre"
                id="nombre"
                value={formData.nombre}
                onChange={handleChange}
                required
              />
            </FormGroup>
            <FormGroup>
              <Label for="correo">Correo Electrónico</Label>
              <Input
                type="email"
                name="correo"
                id="correo"
                value={formData.correo}
                onChange={handleChange}
                required
              />
            </FormGroup>
            <FormGroup>
              <Label for="telefono">Teléfono</Label>
              <PhoneInput
                international
                defaultCountry="PE"
                value={formData.telefono}
                onChange={handlePhoneChange}
                placeholder="Ingresa tu número de teléfono"
                style={{ width: "100%" }}
                className="custom-phone-input"
              />
            </FormGroup>
            <Button type="submit" color="primary" style={{ width: "100%" }}>
              Enviar
            </Button>
          </Form>
        </ModalBody>
      </Modal>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    backgroundColor: "#f5f5f5",
    color: "#333",
  },
  bannerContent: {
    maxWidth: "1200px",
    width: "100%",
    zIndex: 1,
    position: "relative",
  },
  bannerTitle: {
    fontSize: "clamp(28px, 5vw, 48px)",
    fontWeight: "bold",
    color: "#fff",
    marginBottom: "20px",
    textShadow: "2px 2px 4px rgba(0,0,0,0.5)",
    lineHeight: "1.2",
    padding: "0 20px",
  },
  bannerSubtitle: {
    fontSize: "clamp(16px, 3vw, 24px)",
    color: "#fff",
    textShadow: "1px 1px 2px rgba(0,0,0,0.5)",
    lineHeight: "1.6",
    maxWidth: "800px",
    margin: "0 auto 30px",
    padding: "0 20px",
  },
  bannerSection: {
    width: "100%",
    padding: "60px 20px",
    textAlign: "center",
    position: "relative",
    minHeight: "300px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  bannerVideoContainer: {
    width: "100%",
    maxWidth: "800px",
    margin: "30px auto 0",
    borderRadius: "12px",
    overflow: "hidden",
    boxShadow: "0 8px 24px rgba(0,0,0,0.3)",
  },
  bannerVideo: {
    borderRadius: "12px",
  },
  content: {
    textAlign: "center",
    maxWidth: "1200px",
    width: "100%",
    margin: "0 auto",
    padding: "40px 20px",
    backgroundColor: "transparent",
  },
  videoWrapperFull: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
    padding: "20px 0",
  },
  videoWrapper: {
    position: "relative",
    width: "80%",
    paddingTop: "45%",
    margin: "0 auto",
  },
  video: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
  },
  question: {
    width: "100%",
    marginTop: "20px",
    padding: "30px",
    backgroundColor: "#fff",
    borderRadius: "10px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    border: "1px solid #e0e0e0",
  },
  button: {
    display: "block",
    margin: "10px auto",
    padding: "14px 24px",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    backgroundColor: "#1890ff",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    transition: "all 0.3s",
    width: "90%",
    maxWidth: "400px",
    boxShadow: "0 2px 8px rgba(24, 144, 255, 0.3)",
  },
  replayContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    borderRadius: "10px",
  },
  replayImage: {
    width: "150px",
    marginBottom: "20px",
  },
  surveyContainer: {
    marginTop: "20px",
    padding: "24px",
    backgroundColor: "#fff",
    borderRadius: "10px",
    width: "80%",
    marginLeft: "auto",
    marginRight: "auto",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    border: "1px solid #e0e0e0",
  },
  surveyButtons: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    marginTop: "15px",
  },
  surveyButton: {
    padding: "12px 20px",
    fontSize: "16px",
    cursor: "pointer",
    backgroundColor: "#2196F3", // Azul uniforme para todos los botones
    color: "white",
    border: "none",
    borderRadius: "5px",
    transition: "background-color 0.3s",
    width: "100%",
  },
  thankYouMessage: {
    padding: "20px",
    textAlign: "center",
    color: "#333",
  },
  serviciosSection: {
    marginTop: "60px",
    padding: "40px 20px",
    backgroundColor: "#fff",
    borderRadius: "10px",
    width: "100%",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  },
  sectionHeader: {
    marginBottom: "40px",
    textAlign: "center",
  },
  sectionTitle: {
    fontSize: "32px",
    fontWeight: "bold",
    marginBottom: "15px",
    color: "#333",
    textAlign: "center",
  },
  sectionDescription: {
    fontSize: "18px",
    color: "#666",
    lineHeight: "1.6",
  },
  serviciosGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: "30px",
    marginTop: "30px",
  },
  servicioCard: {
    backgroundColor: "#f9f9f9",
    padding: "30px",
    borderRadius: "10px",
    border: "1px solid #e0e0e0",
    transition: "transform 0.3s, box-shadow 0.3s",
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
  },
  servicioTitle: {
    fontSize: "24px",
    fontWeight: "bold",
    marginBottom: "15px",
    color: "#333",
  },
  servicioDescription: {
    fontSize: "16px",
    color: "#666",
    lineHeight: "1.6",
  },
  dosColumnasSection: {
    marginTop: "60px",
    padding: "40px 20px",
    backgroundColor: "#fff",
    borderRadius: "10px",
    width: "100%",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  },
  dosColumnasContent: {
    display: "flex",
    flexWrap: "wrap",
    gap: "40px",
    alignItems: "center",
  },
  columnLeft: {
    width: "100%",
    flex: "1 1 45%",
    minWidth: "300px",
  },
  columnRight: {
    width: "100%",
    flex: "1 1 45%",
    minWidth: "300px",
  },
  imageContainer: {
    width: "100%",
    borderRadius: "10px",
    overflow: "hidden",
  },
  sectionImage: {
    width: "100%",
    height: "auto",
    borderRadius: "10px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
  },
};

export default Usuario;
